import { AxiosError } from "axios";
import { createLogic } from "redux-logic";
import { RootState } from "../../redux/rootReducer";
import { MetricType, MetricsState, useMetricsPublisher } from "../../logging";
import subheaderSlice, {
  GetSubheaderDetailFetchPayload,
} from "./subheaderSlice";
import { Api, http } from "../../http";

import { TeamsResponseDto } from "./SubHeaderDto";
import {
  DefinedPresets,
  getDefinedPresets,
} from "../../common/utils/RosterDataHelper";

const api = new Api(process.env.API_BASE_URL);

const {
  getSubheaderDetailFetch,
  getSubheaderDetailFetchCancel,
  getSubheaderDetailFetchSuccess,
  getSubheaderDetailFetchRejected,
} = subheaderSlice.actions;

export const getTeamUrl = "/api/v1/teams/";

/**
 * Async function that calls get teams endpoint and logs metrics for call.
 *
 * @param {MetricsState} metrics
 * @returns {Promise<any>}
 */
export const getSubheaderDetailFetchFn = async (
  metrics: MetricsState,
  { id }: GetSubheaderDetailFetchPayload
): Promise<any> => {
  const metricsPublisher = useMetricsPublisher(
    metrics,
    getSubheaderDetailFetch.toString()
  );

  const httpMetric = new MetricType.HttpRequest(
    getSubheaderDetailFetch.toString()
  ).withMonitor();

  try {
    let teamId = id;
    if (teamId === "amazon") {
      const definedPresets: DefinedPresets = getDefinedPresets();
      teamId = definedPresets.amazonTeamId;
    }

    const response = await http.get<TeamsResponseDto>(
      api.getEndpointUri(`${getTeamUrl}${teamId}?withBreadcrumbs=true`)
    );
    const result: TeamsResponseDto = response.data;

    httpMetric.statusCode = response.status;
    httpMetric.statusText = response.statusText;
    httpMetric.setSuccess();
    return result;
  } catch (error) {
    console.error(error);

    httpMetric.setFailure();

    const httpError = error as AxiosError;
    if (httpError.response) {
      httpMetric.statusCode = httpError.response.status;
      httpMetric.statusText = httpError.response.statusText;
    }

    throw error;
  } finally {
    metricsPublisher.publish(httpMetric);
  }
};

export const getSubheaderDetailFetchLogic = createLogic({
  type: getSubheaderDetailFetch,
  cancelType: getSubheaderDetailFetchCancel,
  latest: true,

  processOptions: {
    dispatchReturn: true,
    successType: getSubheaderDetailFetchSuccess,
    failType: getSubheaderDetailFetchRejected,
  },

  async process({ getState, action }) {
    const { metrics } = getState() as RootState;
    const response = await getSubheaderDetailFetchFn(metrics, action.payload);
    return response;
  },
});

export default [getSubheaderDetailFetchLogic];
